<template>
    <div class="vs-checkbox">
        <div class="vs-checkbox__wrapper h-100 d-flex align-items-center">
            <div 
                class="vs-checkbox__checkbox-wrapper d-flex justify-content-center"
                @click="handleSelect(values[0])"
            >
                <div
                    class="vs-checkbox__checkbox vs-checkbox__checkbox-a"
                    :class="selected === 2 ? 'active' : 'inactive'"
                >
                    <span class="vs-checkbox__active-icon">
                        <span v-if="selected === 2">
                            <img 
                                v-svg-inline
                                src="@/assets/ui/checkmark-blue-1.svg"
                            />
                        </span>
                    </span>
                </div>

            </div>
            <div 
                class="vs-checkbox__checkbox-wrapper d-flex justify-content-center"
                @click="handleSelect(values[1])"
            >
                <div
                    class="vs-checkbox__checkbox vs-checkbox__checkbox-b"
                    :class="selected === 0 ? 'active' : 'inactive'"
                >
                    <span class="vs-checkbox__active-icon">
                        <span v-if="selected === 0">
                            <img 
                                v-svg-inline
                                src="@/assets/ui/checkmark-red-1.svg"
                            />
                        </span>
                    </span>
                </div>
            </div>

        </div>
    </div>
</template>
<script>
import { ASSETS_URL } from '@/constants/misc'

export default {
    name: 'vsCheckbox',
    props: {
        choice: {
            type: String,
        },
        values: {
            type: Array,
            default: () => [IPSATIVE_CHOICES.HIGHEST, IPSATIVE_CHOICES.LOWEST]
        },
        selected: {}
    },
    data() {
        return {
            ASSETS_URL
        }
    },
    methods: {
        handleSelect(selectedValue) {
            this.$emit('change', {
                choice: this.choice,
                value: selectedValue
            })
        },
    },
}
</script>
<style lang="scss">
    .vs-checkbox__checkbox-wrapper {
        width: 80px;
        margin-right: 8px;
    }

    .vs-checkbox__checkbox {
        height: 28px;
        width: 28px;

        border: 2px solid;
        background-color: transparent !important;
        &:hover {
            cursor: pointer;
            transform: scale(1.2);
            transition: all 0.2s ease;
        }
    }

    .vs-checkbox__checkbox-a {
        border-color: $bq-blue-light;
    }

    .vs-checkbox__checkbox-b {
        border-color: $bq-burgundy-light;
    } 

    .vs-checkbox__checkbox.active {
        transform: scale(1.2);
    }

    .vs-checkbox__checkbox-a.active {
        border-color: $bq-blue !important;
    }

    .vs-checkbox__checkbox-b.active {
        border-color: $bq-burgundy !important;
    }

    .vs-checkbox__checkbox > .vs-checkbox__active-icon {
        display: none;
    }

    .vs-checkbox__checkbox.active > .vs-checkbox__active-icon {
        display: block;
        outline: 0 !important;
        * {
            outline: 0 !important;
        }
    }
</style>